/*
Copyright 2014 Tumbleweed Tiny House Co. All rights reserved.
Created by Martin Adams, August 2014.
*/
  
$(document).ready(function() {

var isLive = true;																		//	Google Analytics has to be turned off in sandbox environment.

/* INSTRUCTIONS:
	1)	LAUNCH VARIABLES
	2)	SELECTION REQUIREMENTS
	3)	FIELD REQUIREMENTS
	4)	MAILCHIMP FIELDS
	4)	USA MAP
	5)	SKYLIGHTS
*/



/*** LAUNCH VARIABLES ***/
//	ENTER GROUP # AND NUMBER OF ELEMENTS FOR EACH GROUP:
var elements = new Array(16);		//	*** SET NUMBER OF GROUPS ***
	elements[0] = new Array(12);		//	MODELS
	elements[1] = new Array(11);		//	ROOF
	elements[2] = new Array(1);		//	DOUBLE-SIDED DORMERS
	elements[3] = new Array(6);		//	SKYLIGHTS
	elements[4] = new Array(2);		//	SHOWER & INTERIOR WALLS
	elements[5] = new Array(14);	//	WINDOWS
	elements[6] = new Array(14);		//	DOOR
	elements[7] = new Array(27);		//	EXTERIOR
	elements[8] = new Array(2);		//	CYPRESS 18'
	elements[9] = new Array(4);		//	CYPRESS 20'
	elements[10] = new Array(8);	//	CYPRESS 24' & 26'
	elements[11] = new Array(2);	//	ELM 18' FLOOR PLANS
	elements[12] = new Array(3);	//	ELM 20' FLOOR PLANS
	elements[13] = new Array(8);	//	ELM 24' FLOOR PLANS
	elements[14] = new Array(3);	//	LINDEN 20' FLOOR PLANS
	elements[15] = new Array(2);	//	DELIVERY FEE
	elements[16] = new Array(11);	//	NEXT STEPS
	elements[17] = new Array(17);	//	CUSTOM FLOOR PLANS
  	elements[18] = new Array(5);	//	FINANCING
/*** LAUNCH VARIABLES ***/



/*** INITIALIZE: DO NOT MODIFY ***/
var beginProcess = false;																//	Set to false so that when user selects first element, variable is set to true
var completeProcess = false;															//	Set to false so that only when user has selected/filled-out all necessary fields variable is set to true
var _gaq = _gaq || [];																	//	Google Analytics
_gaq.push(['_setAccount', 'UA-1771070-1']);
_gaq.push(['_trackPageview']);
(function() {
	var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;
	ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
	var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
})();
for (var i=0; i<=elements.length-1; i++) {
	for (var j=0; j<=elements[i].length-1; j++) {
		var x=(i>9)?i:"0"+i; var y=(j>9)?j:"0"+j;										//	Create global variable "elements[groupID][elementID]" to reference input fields by id, e.g. elements[3][9] => ABR-ID-03-09
		elements[i][j] = "ABR-ID-"+x+"-"+y;												//	Variable references IDs of <input> elements
		$("#ABR-orderItems").append($("<div>", {id:"ABR-item-"+x+"-"+y, class: "ABR-item"}));		//	Create <div id="ABR-item-00-00" class="ABR-item"></div>, etc.
		$("#ABR-orderItems").append($("<div>", {id:"ABR-amount-"+x+"-"+y, class: "ABR-amount"}));	//	Create <div id="ABR-amount-00-00" class="ABR-amount"></div>, etc.
	}
}
var usaMapState = {"AL":["Alabama","#6d3662","#904781","$2,000"],"AR":["Arkansas","#3b5d6a","#4f7d8e","$1,000"],"AZ":["Arizona","#3b5d6a","#4f7d8e","$1,000"],"CA":["California","#6d3662","#904781","$2,000"],"CO":["Colorado","#bb844d","#d99959","$500"],"CT":["Connecticut","#707258","#989b7a","$3,000"],"DC":["Washington D.C.","#707258","#989b7a","$3,000"],"DE":["Delaware","#707258","#989b7a","$3,000"],"FL":["Florida","#707258","#989b7a","$3,000"],"GA":["Georgia","#707258","#989b7a","$3,000"],"IA":["Iowa","#3b5d6a","#4f7d8e","$1,000"],"ID":["Idaho","#3b5d6a","#4f7d8e","$1,000"],"IL":["Illinois","#6d3662","#904781","$2,000"],"IN":["Indiana","#6d3662","#904781","$2,000"],"KS":["Kansas","#3b5d6a","#4f7d8e","$1,000"],"KY":["Kentucky","#6d3662","#904781","$2,000"],"LA":["Louisiana","#6d3662","#904781","$2,000"],"MA":["Massachusetts","#707258","#989b7a","$3,000"],"MD":["Maryland","#707258","#989b7a","$3,000"],"ME":["Maine","#707258","#989b7a","$3,000"],"MI":["Michigan","#6d3662","#904781","$2,000"],"MN":["Minnesota","#6d3662","#904781","$2,000"],"MO":["Missouri","#3b5d6a","#4f7d8e","$1,000"],"MS":["Mississippi","#6d3662","#904781","$2,000"],"MT":["Montana","#3b5d6a","#4f7d8e","$1,000"],"NC":["North Carolina","#707258","#989b7a","$3,000"],"ND":["North Dakota","#3b5d6a","#4f7d8e","$1,000"],"NE":["Nebraska","#3b5d6a","#4f7d8e","$1,000"],"NH":["New Hampshire","#707258","#989b7a","$3,000"],"NJ":["New Jersey","#707258","#989b7a","$3,000"],"NM":["New Mexico","#3b5d6a","#4f7d8e","$1,000"],"NV":["Nevada","#6d3662","#904781","$2,000"],"NY":["New York","#707258","#989b7a","$3,000"],"OH":["Ohio","#6d3662","#904781","$2,000"],"OK":["Oklahoma","#3b5d6a","#4f7d8e","$1,000"],"OR":["Oregon","#6d3662","#904781","$2,000"],"PA":["Pennsylvania","#707258","#989b7a","$3,000"],"RI":["Rhode Island","#707258","#989b7a","$3,000"],"SC":["South Carolina","#707258","#989b7a","$3,000"],"SD":["South Dakota","#3b5d6a","#4f7d8e","$1,000"],"TN":["Tennessee","#6d3662","#904781","$2,000"],"TX":["Texas","#3b5d6a","#4f7d8e","$1,000"],"UT":["Utah","#3b5d6a","#4f7d8e","$1,000"],"VT":["Vermont","#707258","#989b7a","$3,000"],"VA":["Virginia","#707258","#989b7a","$3,000"],"WA":["Washington","#6d3662","#904781","$2,000"],"WV":["West Virginia","#707258","#989b7a","$3,000"],"WI":["Wisconsin","#6d3662","#904781","$2,000"],"WY":["Wyoming","#3b5d6a","#4f7d8e","$1,000"]};
$("#map").usmap({																		//	Customize map
	stateSpecificStyles: {"AL":{fill:usaMapState["AL"][1]},"AR":{fill:usaMapState["AR"][1]},"AZ":{fill:usaMapState["AZ"][1]},"CA":{fill:usaMapState["CA"][1]},"CO":{fill:usaMapState["CO"][1]},"CT":{fill:usaMapState["CT"][1]},"DC":{fill:usaMapState["DC"][1]},"DE":{fill:usaMapState["DE"][1]},"FL":{fill:usaMapState["FL"][1]},"GA":{fill:usaMapState["GA"][1]},"IA":{fill:usaMapState["IA"][1]},"ID":{fill:usaMapState["ID"][1]},"IL":{fill:usaMapState["IL"][1]},"IN":{fill:usaMapState["IN"][1]},"KS":{fill:usaMapState["KS"][1]},"KY":{fill:usaMapState["KY"][1]},"LA":{fill:usaMapState["LA"][1]},"MA":{fill:usaMapState["MA"][1]},"MD":{fill:usaMapState["MD"][1]},"ME":{fill:usaMapState["ME"][1]},"MI":{fill:usaMapState["MI"][1]},"MN":{fill:usaMapState["MN"][1]},"MO":{fill:usaMapState["MO"][1]},"MS":{fill:usaMapState["MS"][1]},"MT":{fill:usaMapState["MT"][1]},"NC":{fill:usaMapState["NC"][1]},"ND":{fill:usaMapState["ND"][1]},"NE":{fill:usaMapState["NE"][1]},"NH":{fill:usaMapState["NH"][1]},"NJ":{fill:usaMapState["NJ"][1]},"NM":{fill:usaMapState["NM"][1]},"NV":{fill:usaMapState["NV"][1]},"NY":{fill:usaMapState["NY"][1]},"OH":{fill:usaMapState["OH"][1]},"OK":{fill:usaMapState["OK"][1]},"OR":{fill:usaMapState["OR"][1]},"PA":{fill:usaMapState["PA"][1]},"RI":{fill:usaMapState["RI"][1]},"SC":{fill:usaMapState["SC"][1]},"SD":{fill:usaMapState["SD"][1]},"TN":{fill:usaMapState["TN"][1]},"TX":{fill:usaMapState["TX"][1]},"UT":{fill:usaMapState["UT"][1]},"VT":{fill:usaMapState["VT"][1]},"VA":{fill:usaMapState["VA"][1]},"WA":{fill:usaMapState["WA"][1]},"WV":{fill:usaMapState["WV"][1]},'WI': {fill: '#6d3662'},"WY":{fill:"#3b5d6a"}},
	stateSpecificHoverStyles: {"AL":{fill:usaMapState["AL"][2]},"AR":{fill:usaMapState["AR"][2]},"AZ":{fill:usaMapState["AZ"][2]},"CA":{fill:usaMapState["CA"][2]},"CO":{fill:usaMapState["CO"][2]},"CT":{fill:usaMapState["CT"][2]},"DC":{fill:usaMapState["DC"][2]},"DE":{fill:usaMapState["DE"][2]},"FL":{fill:usaMapState["FL"][2]},"GA":{fill:usaMapState["GA"][2]},"IA":{fill:usaMapState["IA"][2]},"ID":{fill:usaMapState["ID"][2]},"IL":{fill:usaMapState["IL"][2]},"IN":{fill:usaMapState["IN"][2]},"KS":{fill:usaMapState["KS"][2]},"KY":{fill:usaMapState["KY"][2]},"LA":{fill:usaMapState["LA"][2]},"MA":{fill:usaMapState["MA"][2]},"MD":{fill:usaMapState["MD"][2]},"ME":{fill:usaMapState["ME"][2]},"MI":{fill:usaMapState["MI"][2]},"MN":{fill:usaMapState["MN"][2]},"MO":{fill:usaMapState["MO"][2]},"MS":{fill:usaMapState["MS"][2]},"MT":{fill:usaMapState["MT"][2]},"NC":{fill:usaMapState["NC"][2]},"ND":{fill:usaMapState["ND"][2]},"NE":{fill:usaMapState["NE"][2]},"NH":{fill:usaMapState["NH"][2]},"NJ":{fill:usaMapState["NJ"][2]},"NM":{fill:usaMapState["NM"][2]},"NV":{fill:usaMapState["NV"][2]},"NY":{fill:usaMapState["NY"][2]},"OH":{fill:usaMapState["OH"][2]},"OK":{fill:usaMapState["OK"][2]},"OR":{fill:usaMapState["OR"][2]},"PA":{fill:usaMapState["PA"][2]},"RI":{fill:usaMapState["RI"][2]},"SC":{fill:usaMapState["SC"][2]},"SD":{fill:usaMapState["SD"][2]},"TN":{fill:usaMapState["TN"][2]},"TX":{fill:usaMapState["TX"][2]},"UT":{fill:usaMapState["UT"][2]},"VT":{fill:usaMapState["VT"][2]},"VA":{fill:usaMapState["VA"][2]},"WA":{fill:usaMapState["WA"][2]},"WV":{fill:usaMapState["WV"][2]},'WI': {fill: '#904781'},"WY":{fill:"#4f7d8e"}},
	stateSpecificLabelBackingStyles: {"CT":{fill:usaMapState["CT"][1]},"DC":{fill:usaMapState["DC"][1]},"DE":{fill:usaMapState["DE"][1]},"MA":{fill:usaMapState["MA"][1]},"MD":{fill:usaMapState["MD"][1]},"NH":{fill:usaMapState["NH"][1]},"NJ":{fill:usaMapState["NJ"][1]},"RI":{fill:usaMapState["RI"][1]},"VT":{fill:"#707258"}},
	stateSpecificLabelBackingHoverStyles: {"CT":{fill:usaMapState["CT"][2]},"DC":{fill:usaMapState["DC"][2]},"DE":{fill:usaMapState["DE"][2]},"MA":{fill:usaMapState["MA"][2]},"MD":{fill:usaMapState["MD"][2]},"NH":{fill:usaMapState["NH"][2]},"NJ":{fill:usaMapState["NJ"][2]},"RI":{fill:usaMapState["RI"][2]},"VT":{fill:"#989b7a"}}
});
decisionTree();//	Do first decision run
  
$(".sidebar-financing").draggable();													//	Financing
debiki.Utterscroll.enable({scrollstoppers: '.sidebar, .sidebar-financing, .ready-slider' });		//	Enable utterscroll (scrolling by pressing mouse on page)
//	FINANCING CALCULATOR
$("#slider").slider({
	value:6,
	min: 4,
	max: 12,
	step: 0.25,
	slide: function(event, ui) {
		$("#"+elements[18][3]).val(ui.value + "%");
		financingCalculator();
	}
});
$("#"+elements[18][3]).val($("#slider").slider("value") + "%");
$(".ready-slider").bind("click change", function(e) {financingCalculator()});
if (navigator.userAgent.match(/iPad/i)) {
	var viewportmeta = document.querySelector('meta[name="viewport"]');
	if (viewportmeta) {
		window.onorientationchange = function detectOrientation() {
			if (orientation == 0) {/* Portrait Mode Home Button bottom */ viewportmeta.content = 'user-scalable=yes, width=1400, initial-scale=0.65';}
			else if (orientation == 90) {/* Landscape Mode, Home Button right */ viewportmeta.content = 'user-scalable=yes, width=1100, initial-scale=0.7';}
			else if (orientation == -90) {/* Landscape Mode, Home Button left */ viewportmeta.content = 'user-scalable=yes, width=1100, initial-scale=0.7';}
			else if (orientation == 180) {/* Portrait Mode, Home Button top */ viewportmeta.content = 'user-scalable=yes, width=1400, initial-scale=0.65';}
		}
	}
}
/*** INITIALIZE: DO NOT MODIFY ***/

checkElement(18, 2);																	//	Financing:				Add 10% down as default
hideDiv('ABR-ID-05-03-container');

/*** SELECTION REQUIREMENTS ***/

/*	USE THE FOLLOWING COMMANDS FOR CUSTOMIZING THE CHECKOUT PROCESS:
	*********************************************************************************************************************************************************************************************************
	--- Functions for houses
	HOUSE SIZE (18, 20, 24):	houseSize		();										Returns house size.
								houseSize		(elementID);							Returns house size of element of group 0.
	HOUSE TYPE (e.g. "Linden"):	houseType		();										Returns house type.
								houseType		(elementID);							Returns house type of element of group 0.

	--- Functions for elements
	GROUP CHECKMARKS TOGETHER:	radioGroupA		(groupID, elementID, elementStart, elementEnd);	Groups checkboxes together to simulate radio checkboxes. Will not allow user to deselect.
								radioGroupB		(groupID, elementID, elementStart, elementEnd);	Groups checkboxes together to simulate radio checkboxes. Allows user to deselect.
	IS ELEMENT CHECKED?			isChecked		(groupID, elementID);					Determines if checkbox is checked.
	IS >1 ELEMENT CHECKED?		isGroupChecked	(groupID, elementStart, elementEnd);	Determines if a checkbox in a group of elements is checked.
	IS ELEMENT IN RANGE CHKD?	isRangeChecked	(groupID, elementID, elementStart, elementEnd);			Determines if element selected is in range of certain elements.
	IS ELEMENT VISIBLE?			isVisible		(elementName);							CURRENTLY NOT IN USE | Checks to see if an element is visible.
	FIND SELECTED ELEMENT:		findElement		(groupID, elementStart, elementEnd);	Finds the selected elementID of a selected group. EXCEPTION: returns double-digit element, e.g. "03"
	FIND NAME OF AN ELEMENT:	findElementName	(groupID, elementID);					Finds the name of a selected element.
	SHOW AN ELEMENT:			showElement		(groupID, elementID);					Also enables element. Surrounding div requires "-container", for example: <div id="ABR-ID-07-00-container">element(s) to be hidden</div>
								showElementName (elementName);							Show element
	HIDE AN ELEMENT:			hideElement		(groupID, elementID);					Also unchecks and disables element. Surrounding div requires "-container", for example: <div id="ABR-ID-07-00-container">element(s) to be hidden</div>
								hideElementName (elementName);							Hide element
	CHECK AN ELEMENT:			checkElement	(groupID, elementID);					Also enables the element and adds it to running total.
	CHECK ALL ELEMENTS IN GROUP	checkGroup		(groupID, elementStart, elementEnd);	Checks all elements in a group. Elements must not be in a radio group!
	UNCHECK AN ELEMENT:			unCheckElement	(groupID, elementID);					Deselects element and removes it from running total.
	UNCHECK ELEMENT IN GROUP:	unCheckGroup	(groupID, elementStart, elementEnd);	Deselects any elements in a group.
	IS ELEMENT ENABLED:			isEnabled		(groupID, elementID);					Determines if element is enabled.
	ENABLE ELEMENTS:			enableElement	(groupID, elementID);					Allows user to check an element.
	DISABLE ELEMENTS:			disableElement	(groupID, elementID);					Prevents user from being able to check an element.
    SET ELEMENT VALUE:			setElementValue	(groupID, elementID, text);				Set the value for the specified element.
    SET ELEMENT LABEL:			setLabelValue	(groupID, elementID, text);				Set the value for the specified label.
	ENABLE A GROUP:				enableGroup		(groupID, elementStart, elementEnd);	Allows user to check an element in a group.
	DISABLE A GROUP:			disableGroup	(groupID, elementStart, elementEnd);	Prevents user from being able to check an element in a group.

	--- Functions for sidebar
	ADD VALUE TO CHECKBOX:		addValue		(groupID, elementStart, elementEnd, text);				Adds a value to a group of elements, e.g. "Windows installation $800"
	ADD LABEL CONTENT:			addLabelValue	(groupID, elementStart, elementEnd, item, amount);		Discovers which label has been clicked, then adds the value of the label to its associated checkbox.
	APPEND VALUE TO CHECKBOX:	appendValue		(groupID, elementStart, elementEnd, text);				CURRENTLY NOT IN USE | Appends text to a value of a group of elements.
	ADD ITEM TO TOTAL:			addItem			(groupID, elementID);					Adds item to running total.
								addItemCustom	(groupID, elementID, name, amount);		Adds item to running total and manually assign it an item name and amount.
	REMOVE ITEM FROM TOTAL:		removeItem		(groupID, elementID);					Removes item from running total.
								removeItemName	(elementName);							Adds item to running total by element name.

	--- Other functions
	ADD TO MAILCHIMP			addToMailChimp	(groupID, elementStart, elementEnd, mcGroup);			Finds which element is checked and adds it to MailChimp group
	CREATE DIALOG:				createDialog	(alert text, "confirm", yes-function, no-function);		Alert with "Yes" and "No" button.
								createDialog	(alert text, "alert", function);		Alert with "OK" button.
	DISPLAY FLOOR PLAN:			displayFloorPlan();										Displays floor plan based on house model selected.
	DISPLAY DORMERS:			displayDormers();										Displays dormer based on house model selected.
	GO TO PAGE:					window.location.hash="step-1"							Takes you to anchor tag.
	*********************************************************************************************************************************************************************************************************
*/

function decisionTree (groupID, elementID) {


	//	RADIO CHECKBOXES: ALLOW ONLY ONE CHECKBOX PER GROUP
	if (groupID == 0) {radioGroupA(groupID, elementID, 0, 11);}							//	All models
	if (groupID == 1) {
		radioGroupA(groupID, elementID, 0, 2);											//	Mica Roof types
		radioGroupA(groupID, elementID, 3, 5);											//	Roof options
      	radioGroupA(groupID, elementID, 6, 10);											//	Roof colors
	}
	if (groupID == 5) {
		radioGroupA(groupID, elementID, 0, 2);											//	Window preparation
		//radioGroupB(groupID, elementID, 3, 5);											//	Window size
		radioGroupA(groupID, elementID, 6, 11);											//	Window colors
      	radioGroupA(groupID, elementID, 12, 13);										//	Window colors
	}
	if (groupID == 6) {
		radioGroupB(groupID, elementID, 0, 3);											//	Traditional Door
      	radioGroupB(groupID, elementID, 4, 7);											//	Traditional Door
		radioGroupA(groupID, elementID, 8, 13);											//	Door colors
	}
  	if (groupID == 7) {
		radioGroupB(groupID, elementID, 0, 3);											//	Exterior Siding Options
      	radioGroupB(groupID, elementID, 5, 6);											//	Seal, Stain & Paint Options
      	//radioGroupB(groupID, elementID, 8, 11);											//	Stain Color Options
      	radioGroupB(groupID, elementID, 7, 16);										//	Body Color Options
      	radioGroupB(groupID, elementID, 17, 26);										//	Body Color Options
      	
	}
	if (groupID == 8) {radioGroupA(groupID, elementID, 0, 1);}							//	Cypress 18'
	if (groupID == 9) {radioGroupA(groupID, elementID, 0, 3);}							//	Cypress 20'
	if (groupID == 10) {radioGroupA(groupID, elementID, 0, 3);}							//	Cypress 24'
  	if (groupID == 10) {radioGroupA(groupID, elementID, 4, 7);}							//	Cypress 26'
	if (groupID == 11) {radioGroupA(groupID, elementID, 0, 1);}							//	Elm 18'
	if (groupID == 12) {radioGroupA(groupID, elementID, 0, 2);}							//	Elm 20'
	if (groupID == 13) {radioGroupA(groupID, elementID, 0, 3);}							//	Elm 24'
  	if (groupID == 13) {radioGroupA(groupID, elementID, 4, 7);}							//	Elm 26'
	if (groupID == 14) {radioGroupA(groupID, elementID, 0, 2);}							//	Linden 20'
	if (groupID == 16) {																//	Next Steps Questionnaire
		radioGroupA(groupID, elementID, 0, 3);
		radioGroupA(groupID, elementID, 4, 5);
		radioGroupA(groupID, elementID, 6, 7);
		radioGroupA(groupID, elementID, 8, 9);
	}
	if (groupID == 17) {																//	Custom floor plans
		radioGroupB(groupID, elementID, 0, 2);											//	Back window location
		radioGroupB(groupID, elementID, 3, 6);											//	Porch option
		radioGroupB(groupID, elementID, 7, 16);											//	Back loft selection
	}

	if (groupID == 18) {radioGroupA(groupID, elementID, 0, 2);}						//	Financing - downpayment
  
	//	DISPLAY APPROPRIATE FLOOR PLAN & DORMERS
	displayFloorPlan();
	displayDormers();


	//	MODEL
	if ((groupID>0) && (!isGroupChecked(0, 0, 11))) {
		var alert = "<p>Please select an <strong>RV Model</strong> first.</p>";
		var action = function() {window.location.hash="step-1";}						//	Make sure House Model is selected
		createDialog(alert, "alert", action);
	}
	if (houseType() == "Linden") {														//	If house type is "Linden"
		unCheckElement(2, 0);															//	Uncheck dormers option
      
		$("#ABR-ID-07-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-linden-20.jpg?46105");
      	hideDiv('micaRoofs,micaDoors');
      	showDiv('traditionalDormers,traditionalDoors');
      	setElementValue(5,2,'Windows installation $800');
      	setLabelValue(5,2,'<strong>INSTALLED</strong> $800');
      	hideElement(1, 5); // hide rubber roof
      	unCheckElement(1, 5); // uncheck rubber roof
      	unCheckGroup(1, 0, 2); // uncheck mica roof options
      	if (!isChecked(1, 4) && isGroupChecked(0, 0, 11)) { // if Standing seam not selected, default to ice shield
          checkElement(1, 3);           
        }
      	
    } else if (houseType() == "Mica") {
      	hideDiv('traditionalDormers,traditionalDoors');
      	showDiv('micaRoofs,micaDoors');
      	if (!isGroupChecked(1, 0, 2)) {
          checkElement(1, 0);
          $("#ABR-ID-01-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-roof-shield.jpg?46105");
        }
      	
      	
    } else {
			
		if (isChecked(7, 0)) {
          $("#ABR-ID-07-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/ABR-025_92a9828c-e0fc-46af-b218-8a8d8cf207a1.jpg");
        } else if (isChecked(7, 1)) {
          $("#ABR-ID-07-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/ABR-026_73b427d0-e132-463d-b4d7-4dc83dfdaca2.jpg");
        }
      	hideDiv('micaRoofs,micaDoors');
      	showDiv('traditionalRoofs,traditionalDormers,traditionalDoors');
      	hideElement(1, 5);  // hide rubber roof
      	unCheckElement(1, 5); // uncheck rubber roof
      	unCheckGroup(1, 0, 2); // uncheck mica roof options
      	setElementValue(5,2,'Windows installation $800');
      	setLabelValue(5,2,'<strong>INSTALLED</strong> $800');
     	if (houseSize() == 20) {
          	setElementValue(5,3,'20\' RV Windows $5,000');
      		setLabelValue(5,3,'<strong>20 \' RV WINDOWS</strong> $5,000');
        }
      	if (!isChecked(1, 4) && isGroupChecked(0, 0, 11)) { 			// if Standing seam not selected, default to ice shield
          checkElement(1, 3);           
        }
      	if (houseType() == "Cypress" || houseType() == "Elm") {
      		checkElement(2, 0);
        }
	}
	if ((groupID == 0) && isRangeChecked(groupID, elementID, 0, 11)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '1. Models');}		//	Google Analytics event: model selected
	}

	//	ROOF
	if (isChecked(1, 3)) {
		$("#ABR-ID-01-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-roof-shield.jpg?46105");
		hideDiv('roofColorOptions');															//	Disable roofing options
      	unCheckGroup(1, 6, 9);
	}
	if (isChecked(1, 4)) {
		$("#ABR-ID-01-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-roof-metal.jpg?46105");
		showDiv('roofColorOptions');															//	Enable roofing options
	}
  	if (isChecked(1, 5)) {
		$("#ABR-ID-01-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-mica-rubber-roof_2a361673-3234-4fe0-9c03-7f31f33a1e83.jpg?8748022232650100788");
	}
  	if (isChecked(1, 0)) {
		showElement(1, 5);																//	Show Rubber roof
      	hideElement(1, 4);
      	hideDiv('roofColorOptions');
      	unCheckGroup(1, 6, 9); // uncheck any color options
      	if (!isChecked(1, 5)) {
          checkElement(1, 3);
          $("#ABR-ID-01-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-roof-shield.jpg?46105");
        }
      	
    } else {
      	hideElement(1, 5);
      	showElement(1, 4);
      	if (!isChecked(1, 4)  && isGroupChecked(0, 0, 9)) {
          checkElement(1, 3);
          $("#ABR-ID-01-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-roof-shield.jpg?46105");
        }
    }
  
	if ((groupID == 1) && isRangeChecked(groupID, elementID, 3, 5)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '2. Roof');}			//	Google Analytics event: roof option selected
	}


	//	DORMER WINDOWS
	/*if (houseType() == "Linden") {
      unCheckElement(2, 0);															//	Uncheck dormers option
    } else {
      checkElement(2, 0);
    }*/
	
	/*if (isChecked(2, 0)) {enableGroup(2, 1, 2);}										//	Enable "Windows cut out" and "Dormer Windows"
	else {disableGroup(2, 1, 3);}														//	Disable "Windows cut out" and "Dormer Windows"
	if ((groupID == 2) && (elementID == 1)) {unCheckElement(2, 3);}						//	If "Windows Cut Out", then not "We install"
	if ((groupID == 2) && (elementID == 3)) {unCheckElement(2, 1);}						//	If "We install", disable "Windows Cut Out"
	if (isChecked(2, 2)) {
		enableElement(2, 3);															//	If "Dormer Windows", enable "We install"
		$("#ABR-ID-02-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/dormer-windows.jpg?5578295070753956061");
	} else {
		disableElement(2, 3);															//	If not "Dormer Windows", disable "We install"
		$("#ABR-ID-02-image").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/ABR-014_7d806a0b-ea2f-4cb3-bf50-fdd7d4ad4000.jpg");
	}*/
	/*if (isChecked(2, 0)) {																//	Dormers is checked, therefore houseType() cannot be "Linden"
		if (isChecked(7, 0)) {checkGroup(2, 2, 3); hideElement(7, 0); showElement(7, 1); checkElement(7, 1);}	//	If "Exterior (no dormers)" is selected, switch to "Exterior (with dormers)"
		else {hideElement(7, 0); showElement(7, 1);}									//	Hide "Exterior (no dormers)" and show "Exterior (with dormers)"
	}
	else {
		if (houseType() != "Linden") {															//	If no dormers are selected, and if not Linden:
			if (isChecked(7, 1)) {hideElement(7, 1); showElement(7, 0); checkElement(7, 0);}	//	If "Exterior (with dormers) is selected, switch to "Exterior (no dormers)"
			else {hideElement(7, 1); showElement(7, 0);}										//	Hide "Exterior (with dormers)" and show "Exterior (no dormers)".
		}
		else {																					//	If no dormers are selected, and if Linden:
			if (isChecked(7, 0)) {hideElement(7, 0); showElement(7, 1); checkElement(7, 1);}	//	If "Exterior (no dormers)" is selected, switch to "Exterior (with dormers)"
			else {hideElement(7, 0); showElement(7, 1);}										//	Hide "Exterior (no dormers)" and show "Exterior (with dormers)".
		}
	}*/
	if ((groupID == 2) && isChecked(2, 0)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '3. Dormers');}		//	Google Analytics event: dormer option selected
	}


	//	SKYLIGHTS
  	if (houseType() == "Mica" && !isChecked(1,2)) {
      hideDiv('page-4');
      unCheckGroup(3, 0, 5); // uncheck all skylights
    } else {
      showDiv('page-4');
    }
	if ((houseType() != "Mica" && (houseSize() == 18 || houseSize() == 20))
       || (houseType() == "Mica" && (houseSize() == 20 || houseSize() == 24))) {									//	If house is smaller:
		$("#ABR-ID-03-model").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-skylights-20-hitch.png");	//	Show design for 4 skylights
													//	Hide skylight #5 and #6
      	setElementValue(3, 2,'Skylight (front left) $1,200');
      	setElementValue(3, 3,'Skylight (front right) $1,200');
        if (isChecked(3, 4)) { // handle the case where we go to shoerter trailer and the middle skylights disappear
          	unCheckElement(3, 4);
          	unCheckElement(3, 2);
      		checkElement(3, 2);
        }
  		if (isChecked(3, 5)) { // handle the case where we go to shoerter trailer and the middle skylights disappear
          	unCheckElement(3, 5);
          	unCheckElement(3, 3);
      		checkElement(3, 3);
        }
      	hideElement(3, 4); hideElement(3, 5);
	}
	else {																				//	If house is 24':
		$("#ABR-ID-03-model").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/abr-skylights-24-hitch.png");	//	Select design for 6 skylights
		showElement(3, 4); showElement(3, 5);											//	Show skylight #5 and #6
      	setElementValue(3, 2,'Skylight (middle left) $1,200');
      	setElementValue(3, 3,'Skylight (middle right) $1,200');
      	if (isChecked(3, 2) && groupID == 0) { // handle the case where we go to shoerter trailer and the middle skylights disappear
          	unCheckElement(3, 4);
          	unCheckElement(3, 2);
      		checkElement(3, 4);
        }
  		if (isChecked(3, 3) && groupID == 0) { // handle the case where we go to shoerter trailer and the middle skylights disappear
          	unCheckElement(3, 5);
          	unCheckElement(3, 3);
      		checkElement(3, 5);
        }
	}
	if (isChecked(3,0)) {showElementName("skylight1");}									//	If checkbox is selected, display skylight.
	else {hideElementName("skylight1");}												//	If not selected, hide skylight
	if (isChecked(3,1)) {showElementName("skylight2");}									//	...
	else {hideElementName("skylight2");}												//	See also: $('#ABR-ID-03-model').bind("click", function(e) {...}
	if (isChecked(3,2)) {showElementName("skylight3");}									//	further below.
	else {hideElementName("skylight3");}
	if (isChecked(3,3)) {showElementName("skylight4");}
	else {hideElementName("skylight4");}
	if (isChecked(3,4)) {showElementName("skylight5");}
	else {hideElementName("skylight5");}
	if (isChecked(3,5)) {showElementName("skylight6");}
	else {hideElementName("skylight6");}


	//	WINDOWS
  	if (houseType() == 'Mica') {
    	setElementValue(5,2,'Windows installation');
      	setLabelValue(5,2,'<strong>INSTALLED</strong>');
      	if (houseSize() == 20) {
          	setElementValue(5,3,'20\' RV Windows $3,100');
      		setLabelValue(5,3,'<strong>20\' RV WINDOWS</strong> $3,100');
          	if(isChecked(5, 3)) {addItem(5,3)};
        } else if (houseSize() == 24) {
          	setElementValue(5,3,'24\' RV Windows $3,100');
      		setLabelValue(5,3,'<strong>24\' RV WINDOWS</strong> $3,100');
          	if(isChecked(5, 3)) {addItem(5,3)};
        } else if (houseSize() == 26) {
          	setElementValue(5,3,'26\' RV Windows $3,600');
      		setLabelValue(5,3,'<strong>26\' RV WINDOWS</strong> $3,600');
          	if(isChecked(5, 3)) {addItem(5,3)};
        }
  	} else {
    	setElementValue(5,2,'Windows installation');
      	setLabelValue(5,2,'<strong>INSTALLED</strong>');
      	if (houseSize() == 18) {
          	setElementValue(5,3,'18\' RV Windows $8,300');
      		setLabelValue(5,3,'<strong>18\' RV WINDOWS</strong> $8,300');
            if(isChecked(5, 3)) {addItem(5,3)};
          } else if (houseSize() == 20) {
          	setElementValue(5,3,'20\' RV Windows $8,300');
      		setLabelValue(5,3,'<strong>20\' RV WINDOWS</strong> $8,300');
            if(isChecked(5, 3)) {addItem(5,3)};
        } else if (houseSize() == 24) {
          	setElementValue(5,3,'24\' RV Windows $9,300');
      		setLabelValue(5,3,'<strong>24\' RV WINDOWS</strong> $9,300');
          	if(isChecked(5, 3)) {addItem(5,3)};
        } else if (houseSize() == 26) {
          	setElementValue(5,3,'26\' RV Windows $9,300');
      		setLabelValue(5,3,'<strong>26\' RV WINDOWS</strong> $9,300');
          	if(isChecked(5, 3)) {addItem(5,3)};
        }
  	}
  	// switch window phoitos based on selection
  	if ((groupID == 5) && (elementID == 0)){	//	Covered
		$("#ABR-ID-05").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/windows-covered.jpg?5578295070753956061");
      	unCheckElement(5, 3);
      	hideDiv('ABR-ID-05-03-container');
	}
  	if ((groupID == 5) && (elementID == 1)){	//	Cut out
		$("#ABR-ID-05").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/windows-cutout.jpg?5578295070753956061");
      	unCheckElement(5, 3);
      	hideDiv('ABR-ID-05-03-container');
	}
    if ((groupID == 5) && (elementID == 2)){	//	Installed
		$("#ABR-ID-05").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/windows-installed.jpg?5578295070753956061");
      	checkElement(5, 3);
      	showDiv('ABR-ID-05-03-container');
	}
  
	if ((groupID == 5) && (elementID == 2) && isChecked(5, 2) && !isChecked(5, 3)) {	//	If "Windows Install" has been selected
		checkElement(5, 3);											//	automatically select window
	}
  	if ((groupID == 5) && (elementID == 3) && isChecked(5, 2) && !isChecked(5, 3)) {	//	If "Windows Install" has been selected
		checkElement(5, 3);											//	prevent unselecting windows
	}
  
  	if ((groupID == 5) && (elementID == 3) && !isGroupChecked(5, 11, 12)) {	//	If windows selected default to open
		checkElement(5, 11);											//	prevent unselecting windows
	}

	if (isChecked(5, 3)) {
      showDiv('windowColorOptions');													//	Enable window colors
    } else {
      hideDiv('windowColorOptions');													//	Disable window colors
      unCheckGroup(5, 6, 12);
    }
	
	/*for (i=6; i<=10; i++) {if (isChecked(5, i)) {addItem(5, i);}}						//	Finally, make sure item gets added in case either 18', 20', or 24' windows option is clicked
	if ((groupID == 5) && ((elementID == 2) || isRangeChecked(groupID, elementID, 3, 5))) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '5. Windows');}		//	Google Analytics event: window size selected
	}*/


	//	DOOR
	if (isGroupChecked(6, 1, 3) || isGroupChecked(6, 5, 7)) {
		showDiv('doorColorOptions');															//	Enable door colors
		
	}
	else {
      	hideDiv('doorColorOptions');
      	unCheckGroup(6, 8, 12);
    }																					//	Disable door colors
  
	
	if ((groupID == 6) && isRangeChecked(groupID, elementID, 0, 8)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '6. Doors');}		//	Google Analytics event: door option selected
	}


	//	EXTERIOR
  	if (houseType() == "Mica") {
      if (houseSize() == 20) {
        addValue(7, 1, 1, "Siding: Hot Rolled Steel $7,000"); 
        setLabelValue(7,1,'<strong>HOT ROLLED STEEL</strong> ($7,000)');
        if(isChecked(7, 1)) {addItem(7, 1)}; 
      }
      if (houseSize() == 24) {
        addValue(7, 1, 1, "Siding: Hot Rolled Steel $7,500"); 
        setLabelValue(7, 1 ,'<strong>HOT ROLLED STEEL</strong> ($7,500)');
        if(isChecked(7, 1)) {addItem(7, 1)};
      }
      if (houseSize() == 26) {
        addValue(7, 1, 1, "Siding: Hot Rolled Steel $8,000"); 
        setLabelValue(7, 1 ,'<strong>HOT ROLLED STEEL</strong> ($8,000)');
        if(isChecked(7, 1)) {addItem(7, 1)};
      }
    }
  	// adjust clapboard siding prices based on house length
  	if (houseSize() == 18) {
        addValue(7, 2, 2, 'Siding: Clapboard $4,400'); 
        setLabelValue(7, 2,'<strong>CLAPBOARD</strong> ($4,400)');
        if(isChecked(7, 2)) {addItem(7, 2)}; 
    }
  	if (houseSize() == 20) {
        addValue(7, 2, 2, 'Siding: Clapboard $4,900'); 
        setLabelValue(7, 2,'<strong>CLAPBOARD</strong> ($4,900)');
        if(isChecked(7, 2)) {addItem(7, 2)}; 
    }
  	if (houseSize() == 24) {
        addValue(7, 2, 2, 'Siding: Clapboard $5,400'); 
        setLabelValue(7, 2,'<strong>CLAPBOARD</strong> ($5,400)');
        if(isChecked(7, 2)) {addItem(7, 2)}; 
    }
  	if (houseSize() == 26) {
        addValue(7, 2, 2, 'Siding: Clapboard $5,900'); 
        setLabelValue(7, 2,'<strong>CLAPBOARD</strong> ($5,900)');
        if(isChecked(7, 2)) {addItem(7, 2)}; 
    }
  	// adjust board & batten siding prices based on house length
  	if (houseSize() == 18) {
        addValue(7, 3, 3, 'Siding: Board & Batten $4,400'); 
        setLabelValue(7, 3,'<strong>BOARD & BATTEN</strong> ($4,400)');
        if(isChecked(7, 3)) {addItem(7, 3)}; 
    }
  	if (houseSize() == 20) {
        addValue(7, 3, 3, 'Siding: Board & Batten $4,900'); 
        setLabelValue(7, 3,'<strong>BOARD & BATTEN</strong> ($4,900)');
        if(isChecked(7, 3)) {addItem(7, 3)}; 
    }
  	if (houseSize() == 24) {
        addValue(7, 3, 3, 'Siding: Board & Batten $5,400'); 
        setLabelValue(7, 3,'<strong>BOARD & BATTEN</strong> ($5,400)');
        if(isChecked(7, 3)) {addItem(7, 3)}; 
    }
  	if (houseSize() == 26) {
        addValue(7, 3, 3, 'Siding: Board & Batten $5,900'); 
        setLabelValue(7, 3,'<strong>BOARD & BATTEN</strong> ($5,900)');
        if(isChecked(7, 3)) {addItem(7, 3)}; 
    }
  	
    
  
  	if (houseType() != "Mica") {
      unCheckElement(7, 1);
    }
  	if (houseType() == "Mica") {
      showDiv('hotRolledExterior');
    } else {
      hideDiv('hotRolledExterior');
    }
  	if (isChecked(7, 2) || isChecked(7, 3)) { // wood options
      
      showDiv('woodOptions');
    } else if (isChecked(7, 0) || isChecked(7, 1)) {
      hideDiv('woodOptions');
    }
  	if (isChecked(7, 5)) {
      hideDiv('paintChoices');
      unCheckGroup(7, 7, 26);
    } else if (isChecked(7, 6)) {
      showDiv('paintChoices');      
      //unCheckGroup(7, 7, 26);
    }
  	if (isChecked(7, 1)) {
      showElement(7, 4);
    } else {
      hideElement(7, 4);
    }
  	if (isChecked(7, 4)) {
		$("#ABR-ID-07-01-exterior").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/hot-rolled-steel-aged.jpg?8367043988934732241");
    } else {
      	$("#ABR-ID-07-01-exterior").attr("src", "https://cdn.shopify.com/s/files/1/0150/9532/files/hot-rolled-steel.jpg?8367043988934732241");
    }
	/*if (isChecked(7, 0) || isChecked(7, 1)) {
		var gotoStep = new Array(10);
		var i = 0;
		var missing = "";
		if (!isGroupChecked(0, 0, 6)) {missing += "<strong>• Model</strong><br />"; gotoStep[i] = "step-1"; i++;}
		if (!isChecked(1, 1)) {missing += "<strong>• Roof</strong><br />"; gotoStep[i] = "step-2"; i++;}
		if (!isGroupChecked(1, 2, 5)) {missing += "<strong>• Roof Color</strong><br />"; gotoStep[i] = "step-2"; i++;}
		if (isChecked(7, 1) && (houseType() != "Linden") && !isChecked(2, 2)) {missing += "<strong>• Dormer Windows</strong><br />"; gotoStep[i] = "step-3"; i++;}
		if (isChecked(7, 1) && (houseType() != "Linden") && !isChecked(2, 3)) {missing += "<strong>• Dormer Installation</strong><br />"; gotoStep[i] = "step-3"; i++;}
		if (!isGroupChecked(5, 3, 5)) {missing += "<strong>• Window</strong><br />"; gotoStep[i] = "step-5"; i++;}
		if (!isChecked(5, 2)) {missing += "<strong>• Window Installation</strong><br />"; gotoStep[i] = "step-5"; i++;}
		if (!isGroupChecked(5, 6, 10)) {missing += "<strong>• Window Color</strong><br />"; gotoStep[i] = "step-5"; i++;}
		if (!isChecked(6, 0)) {missing += "<strong>• Complete Door</strong><br />"; gotoStep[i] = "step-6"; i++;}
		if (!isGroupChecked(6, 4, 8)) {missing += "<strong>• Door Color</strong><br />"; gotoStep[i] = "step-6";}
 		if (missing != "") {
			if (isChecked(7, 0)) {var option = "(NO DORMERS)"; unCheckElement(7, 0);}
			if (isChecked(7, 1)) {var option = "(WITH DORMERS)"; unCheckElement(7, 1);}
			var alert = "<p>You need to select the following options before you can select the <strong>COMPLETE EXTERIOR</strong> "+option+" option.</p><p>"+missing+"</p><p>Would you like to select those options now?</p>";
			var ifYes = function() {window.location.hash=gotoStep[0];}
			var ifNo = function() {}
			createDialog(alert, "confirm", ifYes, ifNo);
		}
	}
	if (isChecked(7, 0)) {
		if (houseSize() == 18) {addValue(7, 0, 0, "Complete exterior (no dormers) $5,100"); addItem(7, 0);}
		if (houseSize() == 20) {addValue(7, 0, 0, "Complete exterior (no dormers) $5,600"); addItem(7, 0);}
		if (houseSize() == 24) {addValue(7, 0, 0, "Complete exterior (no dormers) $5,600"); addItem(7, 0);}
	}
	if (isChecked(7, 1)) {
		if (houseType() == "Linden") {addValue(7, 1, 1, "Complete exterior (with dormers) $5,600"); addItem(7, 1);}
		if (houseType() != "Linden") {
			if (houseSize() == 18) {addValue(7, 1, 1, "Complete exterior (with dormers) $5,000"); addItem(7, 1);}
			if (houseSize() == 20) {addValue(7, 1, 1, "Complete exterior (with dormers) $5,500"); addItem(7, 1);}
			if (houseSize() == 24) {addValue(7, 1, 1, "Complete exterior (with dormers) $5,500"); addItem(7, 1);}
		}
	}*/
	if ((groupID == 7) && isRangeChecked(groupID, elementID, 0, 3)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '7. Exterior');}		//	Google Analytics event: dormer option selected
	}


	//	FLOOR PLANS
  	if (houseType() == "Mica") {
      hideDiv('CustomFloorPlan');
    } else {
      showDiv('CustomFloorPlan');
    }
	if ((houseType() == "Cypress") && (houseSize() == 18)) {
		if (isGroupChecked(8, 0, 1)) {$("#floorPlan").text(findElementName(8, 0, 1));}	//	Update the name of the floor plan on the "Interior" page for "Interior Walls Framed"
		unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7); unCheckGroup(14, 0, 2);	//	Make sure all other floor plans are not checked
	}
	if ((houseType() == "Cypress") && (houseSize() == 20)) {
		if (isGroupChecked(9, 0, 3)) {$("#floorPlan").text(findElementName(9, 0, 3));}
		unCheckGroup(8, 0, 1); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7); unCheckGroup(14, 0, 2);
	}
	if ((houseType() == "Cypress") && (houseSize() == 24)) {
		if (isGroupChecked(10, 0, 7)) {$("#floorPlan").text(findElementName(10, 0, 7));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 4, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7); unCheckGroup(14, 0, 2);
	}
  	if ((houseType() == "Cypress") && (houseSize() == 26)) {
		if (isGroupChecked(10, 0, 7)) {$("#floorPlan").text(findElementName(10, 0, 7));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 3); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7); unCheckGroup(14, 0, 2);
	}
	if ((houseType() == "Elm") && (houseSize() == 18)) {
		if (isGroupChecked(11, 0, 1)) {$("#floorPlan").text(findElementName(11, 0, 1));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7); unCheckGroup(14, 0, 2);
	}
	if ((houseType() == "Elm") && (houseSize() == 20)) {
		if (isGroupChecked(12, 0, 2)) {$("#floorPlan").text(findElementName(12, 0, 2));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(13, 0, 7); unCheckGroup(14, 0, 2);
	}
	if ((houseType() == "Elm") && (houseSize() == 24)) {
		if (isGroupChecked(13, 0, 3)) {$("#floorPlan").text(findElementName(13, 0, 3));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 4, 7); unCheckGroup(14, 0, 2);
	}
  	if ((houseType() == "Elm") && (houseSize() == 26)) {
		if (isGroupChecked(13, 0, 3)) {$("#floorPlan").text(findElementName(13, 0, 3));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 3); unCheckGroup(14, 0, 2);
	}
	if ((houseType() == "Linden") && (houseSize() == 20)) {
		if (isGroupChecked(14, 0, 2)) {$("#floorPlan").text(findElementName(14, 0, 2));}
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7);
	}
  	if (houseType() == "Mica") {
		
		unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 7); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 7);unCheckGroup(14, 0, 2);
	}
	if (isChecked(9, 0) && isChecked(2, 0)) {											//	Cypress 20' Arise doesn't allow dormers
		var alert = "Dormers are not available with the <strong>Cypress 20’ Arise</strong> model. Do you want to remove the dormers?";
		var ifYes = function() {disableGroup(2, 0, 3);}									//	Disable dormers if Cypress 20' Arise is selected
		var ifNo = function() {unCheckElement(9, 0);}									//	Don't select Cypress 20' Arise
		createDialog(alert, "confirm", ifYes, ifNo);
	}
	else if (isChecked(9, 0) && !isChecked(2, 0)) {disableGroup(2, 0, 3);}				//	Disable dormers if Cypress 20' Arise is selected
	else if (!isChecked(9, 0) && !isEnabled(2, 0)) {enableElement(2, 0);}				//	Enable dormers if Cypress 20' Arise isn't selected
	if	(
		((groupID == 8) || (groupID == 9) || (groupID == 10) || (groupID == 11) || (groupID == 12) || (groupID == 13) || (groupID == 14))
		&&
		(isRangeChecked(8, elementID, 0, 1) || isRangeChecked(9, elementID, 0, 3) || isRangeChecked(10, elementID, 0, 3) || isRangeChecked(11, elementID, 0, 1) || isRangeChecked(12, elementID, 0, 2) || isRangeChecked(13, elementID, 0, 3) || isRangeChecked(14, elementID, 0, 2))
		) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '8. Floor plan');}	//	Google Analytics event: floor plan selected
	}
	if (isGroupChecked(17, 0, 16) && (isGroupChecked(8, 0, 1)  || isGroupChecked(9, 0, 3)  || isGroupChecked(10, 0, 3) || isGroupChecked(11, 0, 1) ||
		isGroupChecked(12, 0, 2) || isGroupChecked(13, 0, 3) || isGroupChecked(14, 0, 2))) {
		var alert = "You have a preexisting floor plan as well as custom options selected. You can either select a preexisting floor plan or customize your floor plan. Would you like to deselect the floor plan and customize it instead?";
		var ifYes = function() {unCheckGroup(8, 0, 1); unCheckGroup(9, 0, 3); unCheckGroup(10, 0, 3); unCheckGroup(11, 0, 1); unCheckGroup(12, 0, 2); unCheckGroup(13, 0, 3); unCheckGroup(14, 0, 2);}
		var ifNo = function() {unCheckGroup(17, 0, 16);}
		createDialog(alert, "confirm", ifYes, ifNo);
	}
	if ((groupID == 17) && isRangeChecked(groupID, elementID, 0, 16)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '8. Custom floor plan');} //	Google Analytics event: custom floor plan options
	}

	//	INTERIOR
	if ((groupID == 4) && isRangeChecked(groupID, elementID, 0, 1)) {
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '9. Interior');}		//	Google Analytics event: interior options selected
	}


	//	DELIVERY
	if ((groupID == 15) && isChecked(15, 0)) {
		unCheckElement(15, 1);															//	Uncheck state delivery (hidden)
		removeItem(15, 1);																//	Remove state from running total
		for (key in usaMapState) {$("#"+key).css("fill", usaMapState[key][1]);}			//	Deselect all states for pickup
		if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '10. Delivery');}	//	Google Analytics event: delivery option selected
	}


	//	LEAD SCORE
	var leadScore = 0;
	if (isChecked(16, 0)) {leadScore += 5;} // 0-6 mo
	if (isChecked(16, 1)) {leadScore += 1;} // 7-12 mo
	if (isChecked(16, 4)) {leadScore += 4;} // has location
	if (isChecked(16, 7)) {leadScore += 1;} // no financing
	//if (isChecked(16, 9)) {leadScore += 3;}
	$("#MCLEADSCOR").val(leadScore);
  
  	financingCalculator();
}
/*** SELECTION REQUIREMENTS ***/



/*** FIELD REQUIREMENTS ***/
function checkFields() {
	var gotoStep = new Array(9);
	var i = 0;
	var alert = "";
	/*if (!isGroupChecked(0, 0, 9)) {alert += "<strong>• RV Model</strong><br />"; gotoStep[i] = "step-1"; i++;}
	if (isChecked(1, 1) && (!isGroupChecked(1, 2, 5))) {alert += "<strong>• Roof Color</strong><br />"; gotoStep[i] = "step-2"; i++;}
	if (isGroupChecked(5, 3, 5) && !isGroupChecked(5, 6, 10)) {alert += "<strong>• Window Color</strong><br />"; gotoStep[i] = "step-5"; i++;}
	if (isGroupChecked(6, 0, 1) && !isGroupChecked(6, 4, 8)) {alert += "<strong>• Door Color</strong><br />"; gotoStep[i] = "step-6"; i++;}*/
	/*if (!isGroupChecked(8, 0, 1) && !isGroupChecked(9, 0, 3) && !isGroupChecked(10, 0, 3) && !isGroupChecked(11, 0, 1) && !isGroupChecked(12, 0, 2) && !isGroupChecked(13, 0, 3) && !isGroupChecked(14, 0, 2)) {
		if (!isGroupChecked(17, 0, 16)) {alert += "<strong>• Floor Plan</strong><br />"; gotoStep[i] = "step-8"; i++;}
		else {
			if (!isGroupChecked(17, 0, 2)) {alert += "<strong>• Custom Floor Plan (back window)</strong><br />"; gotoStep[i] = "step-8"; i++;}
			if (!isGroupChecked(17, 3, 6)) {alert += "<strong>• Custom Floor Plan (porch)</strong><br />"; gotoStep[i] = "step-8"; i++;}
			if (!isGroupChecked(17, 7, 16)) {alert += "<strong>• Custom Floor Plan (back loft)</strong><br />"; gotoStep[i] = "step-8"; i++;}
		}
	}*/
	if (!isGroupChecked(15, 0, 1)) {alert += "<strong>• Delivery</strong>"; gotoStep[i] = "step-10";}
	if (alert != "") {
		alert = "<p>Please select the following options before you schedule a free consult.</p><p>"+alert+"</p>";
		var action = function() {window.location.hash=gotoStep[0];}
		createDialog(alert, "alert", action);
		return false;
	}
	var alert = "";																		//	Make sure next steps are completed
	if (!isGroupChecked(16, 0, 3)) {alert += "Please let us know your <strong>timeline</strong>";}
	if (!isGroupChecked(16, 4, 5)) {if (alert!="") {alert += ". Also, please ";} else {alert += "Please ";} alert += "let us know if you already have a <strong>location</strong> for your house";}
	//if (!isGroupChecked(16, 6, 7)) {if (alert!="") {alert += " and if ";} else {alert += "Please let us know if ";} alert += "you’ve already figured out <strong>who’s going to help you finish</strong> your RV"}
	if (!isGroupChecked(16, 6, 7)) {if (alert!="") {alert += ". Also let us know if ";} else {alert += "Please let us know if ";} alert += "you need to obtain <strong>financing</strong>"}
	if (alert != "") {
		alert += ".";
		var ok = function() {window.location.hash="step-11";}
		createDialog(alert, "alert", ok);
		return false;
	}
	var alert = "";																		//	Make sure MailChimp form is filled out
	if ($("#FNAME").val()=="") {alert += "Please fill in your first name";}
	if ($("#LNAME").val()=="") {if (alert!="") {if(($("#EMAIL").val()=="") && ($("#PHONE").val()!="")) {alert += ", ";} else {alert += " and ";} alert += "last name";} else {alert += "Please fill in your last name";}}
	if ($("#PHONE").val()=="") {if (alert!="") {alert += ". We also need your phone number";} else {alert += "Please fill in your phone number";}}
	if ($("#EMAIL").val()=="") {if (alert!="") {alert += " and email address";} else {alert += "Please fill in your email address";}}
	if (alert != "") {
		alert += ".";
		var ok = function() {window.location.hash="step-11";}
		createDialog(alert, "alert", ok);
		return false;
	}
  	if (isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', 'End');}			//	Google Analytics event: submit button fired, all required fields filled out
	$.blockUI({ message: '<script>$(function() { $(".meter > span").each(function() {$(this).data("origWidth", $(this) .width()) .width(0) .animate({width: $(this).data("origWidth")}, 60000);});});</script><div class="meter animate"><span style="width: 340px"></span></div><h1>We are preparing your custom quote.  This may take a few minutes so please be patient.<br /><br /> Hitting the back button will result in lost data...</h1>' });
  	completeProcess = true;
}
/*** FIELD REQUIREMENTS ***/



/*** MAILCHIMP FIELDS ***/
function initMailChimp() {
	if (isGroupChecked(0, 0, 11)) {addToMailChimp(0, 0, 11, "HOUSE");}					//	Group results into MailChimp options
	if (isGroupChecked(1, 0, 2)) {addToMailChimp(1, 0, 2, "ROOFSTYLE");}
  	if (isGroupChecked(1, 3, 5)) {addToMailChimp(1, 3, 5, "ROOFTYPE");}
  	if (isGroupChecked(1, 6, 10)) {addToMailChimp(1, 6, 10, "ROOFCOLOR");}
	if (isChecked(2, 0)) {addToMailChimp(2, 0, 0, "DORMFRM");}
	/*if (isChecked(2, 2)) {addToMailChimp(2, 2, 2, "DORMWIN");}
	if (isChecked(2, 1)) {addToMailChimp(2, 1, 1, "DORMINST");}							//	Add either "Windows Cut Out" or "Dormer Installation"
	if (isChecked(2, 3)) {addToMailChimp(2, 3, 3, "DORMINST");}							//	...*/
	if (isChecked(3, 0)) {addToMailChimp(3, 0, 0, "SKY1");}
	if (isChecked(3, 1)) {addToMailChimp(3, 1, 1, "SKY2");}
	if (isChecked(3, 2)) {addToMailChimp(3, 2, 2, "SKY3");}
	if (isChecked(3, 3)) {addToMailChimp(3, 3, 3, "SKY4");}
	if (isChecked(3, 4)) {addToMailChimp(3, 4, 4, "SKY5");}
	if (isChecked(3, 5)) {addToMailChimp(3, 5, 5, "SKY6");}
	if (isGroupChecked(5, 0, 2)) {addToMailChimp(5, 0, 2, "WINPREP");}					//	Add either "Covered", "Cut Out", or "Installed"
	if (isChecked(5, 3)) {addToMailChimp(5, 3, 3, "WINDOWS");}
  	if (isGroupChecked(5, 6, 11)) {addToMailChimp(5, 6, 11, "WINDOWCOLOR");}
  	if (isGroupChecked(5, 12, 13)) {addToMailChimp(5, 12, 13, "WINDOWSTYLE");}
	if (isGroupChecked(6, 0, 3)) {addToMailChimp(6, 0, 3, "TRADITIONALDOOR");}
  	if (isGroupChecked(6, 4, 7)) {addToMailChimp(6, 4, 7, "MICADOOR");}
  	if (isGroupChecked(6, 8, 13)) {addToMailChimp(6, 8, 13, "DOORCOLOR");}
	if (isGroupChecked(7, 0, 3)) {addToMailChimp(7, 0, 3, "SIDING");}
  	if (isChecked(7, 4)) {addToMailChimp(7, 4, 4, "AGED");}
  	if (isGroupChecked(7, 5, 6)) {addToMailChimp(7, 5, 7, "SIDINGTREATMENT");}
  	/*if (isGroupChecked(7, 8, 11)) {addToMailChimp(7, 8, 11, "SIDINGSTAIN");}*/
  	if (isGroupChecked(7, 7, 16)) {addToMailChimp(7, 12, 21, "SIDINGBODY");}
  	if (isGroupChecked(7, 17, 26)) {addToMailChimp(7, 22, 31, "SIDINGTRIM");}
	if (isGroupChecked(8, 0, 1)) {addToMailChimp(8, 0, 1, "FLRPLAN");}
	if (isGroupChecked(9, 0, 3)) {addToMailChimp(9, 0, 3, "FLRPLAN");}
	if (isGroupChecked(10, 0, 7)) {addToMailChimp(10, 0, 7, "FLRPLAN");}
	if (isGroupChecked(11, 0, 1)) {addToMailChimp(11, 0, 1, "FLRPLAN");}
	if (isGroupChecked(12, 0, 2)) {addToMailChimp(12, 0, 2, "FLRPLAN");}
	if (isGroupChecked(13, 0, 7)) {addToMailChimp(13, 0, 7, "FLRPLAN");}
	if (isGroupChecked(14, 0, 2)) {addToMailChimp(14, 0, 2, "FLRPLAN");}
	if (isGroupChecked(17, 0, 2)) {addToMailChimp(17, 0, 2, "CSTMBWIN");}
	if (isGroupChecked(17, 3, 6)) {addToMailChimp(17, 3, 6, "CSTMPRCH");}
	if (isGroupChecked(17, 7, 16)) {addToMailChimp(17, 7, 16, "CSTMLOFT");}
	if (isChecked(4, 0)) {addToMailChimp(4, 0, 0, "SHOWER");}
	if (isChecked(4, 1)) {addToMailChimp(4, 1, 1, "INTWALLS");}
	if (isGroupChecked(15, 0, 1)) {addToMailChimp(15, 0, 1, "DELIVERY");}
	if (isChecked(16, 0)) {addToMailChimp(16, 0, 0, "TIMELINE", "0 - 6 months");}		//	Custom values (e.g. "0 - 6 months") are used in MailChimp form to determine custom content.
	if (isChecked(16, 1)) {addToMailChimp(16, 1, 1, "TIMELINE", "7 - 12 months");}
	if (isChecked(16, 2)) {addToMailChimp(16, 2, 2, "TIMELINE", "1 year or more");}
	if (isChecked(16, 3)) {addToMailChimp(16, 3, 3, "TIMELINE", "Not sure");}
	if (isChecked(16, 4)) {addToMailChimp(16, 4, 4, "FINISH", "Has help finishing");}
  	if (isChecked(16, 5)) {addToMailChimp(16, 5, 5, "FINISH", "Does not have help finishing");}
  	if (isChecked(16, 6)) {addToMailChimp(16, 6, 6, "LOCATION", "Has location");}
  	if (isChecked(16, 7)) {addToMailChimp(16, 7, 7, "LOCATION", "Does not have location");}
  	//if (isChecked(16, 8)) {addToMailChimp(16, 8, 8, "FINANCE", "Need financing");}
  	//if (isChecked(16, 9)) {addToMailChimp(16, 9, 9, "FINANCE", "Does not need financing");}
}
function addToMailChimp (groupID, elementStart, elementEnd, mcGroup, customValue) {
	var x=(groupID>9)?groupID:"0"+groupID;
	if ($("#ABR-item-"+x+"-"+findElement(groupID, elementStart, elementEnd)).text() == "") {
  
		$("#MC"+mcGroup).val(customValue);
	}
	else {
      	
		$("#MC"+mcGroup).val($("#ABR-item-"+x+"-"+findElement(groupID, elementStart, elementEnd)).text()+" "+$("#ABR-amount-"+x+"-"+findElement(groupID, elementStart, elementEnd)).text());
	}
	$("#MCTOTAL").val($("#ABR-total-amount").text());
	
}
/*** MAILCHIMP FIELDS ***/



/*** USA MAP ***/
$('#map').on('usmapclick', function(event, data) {										//	If user clicks on delivery map
	unCheckElement(15, 0);																//	Uncheck free pickup
	checkElement(15, 1);																//	Check State selected.
	addItemCustom(15, 1, "Delivery: "+usaMapState[data.name][0], usaMapState[data.name][3]);	//	Add state to running total
	for (key in usaMapState) {$("#"+key).css("fill", usaMapState[key][1]);}						//	Restore all previously selected states to default color
	$("#"+data.name).css("fill", "#b8b8b8");											//	Fill selected state with a special color
	if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', '10. Delivery');}		//	Google Analytics event: delivery option selected
  	financingCalculator();
});
/*** USA MAP ***/

/*** FINANCING CALCULATOR ***/
function financingCalculator() {
	
	if ((calculateTotal() > 0) && isGroupChecked(18, 0, 2)) {								//	Only calculate if total > $0 and downpayment option has been selected
		if (isChecked(18, 0))		{var loan = calculateTotal();}
		else if (isChecked(18, 1))	{var loan = 0.9*calculateTotal();}
		else if (isChecked(18, 2))	{var loan = 0.8*calculateTotal();}
		var rateAmount = $("#"+elements[18][3]).val().split("%");
		var rate = rateAmount[0]/1200
		var payment = Math.round(loan * (rate * Math.pow(1 + rate, 84)) / (Math.pow(1 + rate, 84) - 1), 0);
		$("#"+elements[18][4]).val("$"+numberWithCommas(payment));
	}
	else {$("#"+elements[18][4]).val("$0")}
}
/*** FINANCING CALCULATOR ***/

/*** SKYLIGHTS ***/
var clickEvent = false;
$('#ABR-ID-03-model').bind("click", function(e) {										//	Determine location of click to activate skylight
	var x = e.pageX - $(this).offset().left; var y = e.pageY - $(this).offset().top;
	if ((x>=24) && (x<=85) && (y>=248) && (y<=332)) {showElementName("skylight1"); checkElement(3, 0); clickEvent = true;}
	if ((x>=138) && (x<=200) && (y>=248) && (y<=332)) {showElementName("skylight2"); checkElement(3, 1); clickEvent = true;}
	if ((x>=24) && (x<=85) && (y>=402) && (y<=485)) {showElementName("skylight3"); checkElement(3, 2); clickEvent = true;}
	if ((x>=138) && (x<=200) && (y>=402) && (y<=485)) {showElementName("skylight4"); checkElement(3, 3); clickEvent = true;}
	if ((x>=24) && (x<=85) && (y>=557) && (y<=639)) {showElementName("skylight5"); checkElement(3, 4); clickEvent = true;}
	if ((x>=138) && (x<=200) && (y>=557) && (y<=639)) {showElementName("skylight6"); checkElement(3, 5); clickEvent = true;}
	if (isLive && clickEvent) {ga('send', 'event', 'Amish Barn Raiser Guide', '4. Skylights');}
});
$("#skylight1").bind("click", function(e) {hideElementName("skylight1"); unCheckElement(3, 0);});
$("#skylight2").bind("click", function(e) {hideElementName("skylight2"); unCheckElement(3, 1);});
$("#skylight3").bind("click", function(e) {hideElementName("skylight3"); unCheckElement(3, 2);});
$("#skylight4").bind("click", function(e) {hideElementName("skylight4"); unCheckElement(3, 3);});
$("#skylight5").bind("click", function(e) {hideElementName("skylight5"); unCheckElement(3, 4);});
$("#skylight6").bind("click", function(e) {hideElementName("skylight6"); unCheckElement(3, 5);});
/*** SKYLIGHTS ***/



/*** NAVIGATION: DO NOT MODIFY ***/
$(".sidebar").draggable({
	revert: "invalid"
});
/*** NAVIGATION: DO NOT MODIFY ***/



/*** ELEMENT FUNCTIONS: DO NOT MODIFY ***/
function houseSize (house) {
	if (house !== undefined) {
		if (house==0 || house==4) {return 18;}
		if (house==1 || house==5 || house==8 || house==9) {return 20;}
		if (house==2 || house==6 || house==10) {return 24;}
      	if (house==3 || house==7 || house==11) {return 26;}
	}
	else {
		for (var i=0; i<=elements[0].length-1; i++) {
			if (isChecked(0, i)) {
				if (i==0 || i==4) {return 18;}
				if (i==1 || i==5 || i==8 || i==9) {return 20;}				
              	if (i==2 || i==6 || i==10) {return 24;}
              	if (i==3 || i==7 || i==11) {return 26;}
			}
		}
	}
}
function houseType (house) {
	if (house !== undefined) {
		if (house==0 || house==1 || house==2 || house==3) {return "Cypress";}
		if (house==4 || house==5 || house==6 || house==7) {return "Elm";}
		if (house==8) {return "Linden";}
      	if (house==9 || house==10 || house==11) {return "Mica";}
	}
	else {
		for (var i=0; i<=elements[0].length-1; i++) {
			if (isChecked(0, i)) {
				if (i==0 || i==1 || i==2 || i==3) {return "Cypress";}
				if (i==4 || i==5 || i==6 || i==7) {return "Elm";}
				if (i==8) {return "Linden";}
              	if (i==9 || i==10 || i==11) {return "Mica";}
			}
		}
	}
}
function displayFloorPlan () {
	for (var i=0; i<=elements[0].length-1; i++) {
		var floorPlan = houseType(i) + "-" + houseSize(i);
      	floorPlan = floorPlan.replace("26","24");
      	if (houseType(i) == 'Cypress' && houseSize(i) == 26 && isChecked(0, 3)) {
          console.log('floorplan = '+ i);
          showDiv('cypress26FloorPlans');
          hideDiv('cypress24FloorPlans');
        
        } else if (houseType(i) == 'Cypress' && houseSize(i) == 24 && isChecked(0, 2)) {
          showDiv('cypress24FloorPlans');
          hideDiv('cypress26FloorPlans');
        }
      	if (houseType(i) == 'Elm' && houseSize(i) == 26 && isChecked(0, 7)) {
          console.log('floorplan = '+ i);
          showDiv('elm26FloorPlans');
          hideDiv('elm24FloorPlans');
        
        } else if (houseType(i) == 'Elm' && houseSize(i) == 24 && isChecked(0, 6)) {
          showDiv('elm24FloorPlans');
          hideDiv('elm26FloorPlans');
        }
     	
		if (isChecked(0, i) || (i==3 && isChecked(0, 2)) || (i==7 && isChecked(0, 6))) {
          	
			document.getElementById(floorPlan).style.display = "block";
			$("#FloorPlanNotice").hide();
		}
		else {
			document.getElementById(floorPlan).style.display = "none";
		}
      	
	}
}
function displayDormers() {
	if (houseType() == "Linden") {
		document.getElementById("dormers-linden").style.display = "block";
		document.getElementById("dormers").style.display = "none";
	}
	else {
		document.getElementById("dormers-linden").style.display = "none";
		document.getElementById("dormers").style.display = "block";
	}
}
function findElement (groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {
		if (isChecked(groupID, i)) {return (i>9)?i:"0"+i;}								//	Exception to the rule: returns element as double-digit, e.g. "03" instead of "3"
	}
	return;
}
function findElementName (groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {
		if (isChecked(groupID, i)) {
			var elementName = $("#"+elements[groupID][i]).val();
			elementName = elementName.split("$");
			return elementName[0].substring(0,elementName[0].length);
		}
	}
}
function numberWithCommas (x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function calculateTotal () {
	var itemAmount = 0;
	for (var i=0; i<=elements.length-1; i++) {
		for (var j=0; j<=elements[i].length-1; j++) {
			var x=(i>9)?i:"0"+i; var y=(j>9)?j:"0"+j;
			var isError = isNaN(parseInt($("#ABR-amount-"+x+"-"+y).html().substring(1,$("#ABR-amount-"+x+"-"+y).html().length).replace(/,/g, ''), 10));
			itemAmount += (isError ? 0 : parseInt($("#ABR-amount-"+x+"-"+y).html().substring(1,$("#ABR-amount-"+x+"-"+y).html().length).replace(/,/g, ''), 10));
		}
	}
    /*if (itemAmount > 500) {
		$("#ABR-discount").show();
      	itemAmount = itemAmount - 500;
    } else {
      	$("#ABR-discount").hide();
    }*/
	$("#ABR-total-amount").html("$"+numberWithCommas(itemAmount));
  	return itemAmount;
}
function addItem (groupID, elementID) {
	if (($("#"+elements[groupID][elementID]).val() != undefined) && ($("#"+elements[groupID][elementID]).val() != "") && groupID != 18) {
		var elementValue = $("#"+elements[groupID][elementID]).val();
		elementValue = elementValue.split("$");
		if (elementValue.length > 1) {													//	If element value has both an item and an amount
			elementValue[0] = elementValue[0].substring(0,elementValue[0].length-1);
			elementValue[1] = "$" + elementValue[1];
			var x=(groupID>9)?groupID:"0"+groupID; var y=(elementID>9)?elementID:"0"+elementID;
			$("#ABR-item-"+x+"-"+y).html(elementValue[0]);								//	Fill in item in running total
			$("#ABR-amount-"+x+"-"+y).html(elementValue[1]);							//	Fill in amount in running total
			var addTotal = calculateTotal();
          	financingCalculator();
		}
		else {
			if (groupID>9) {x=groupID;} else {x="0"+groupID;}
			if (elementID>9) {y=elementID;} else {y="0"+elementID;}
			$("#ABR-item-"+x+"-"+y).html(elementValue[0]);
		}
	}
}
function removeItem (groupID, elementID) {
	var x=(groupID>9)?groupID:"0"+groupID; var y=(elementID>9)?elementID:"0"+elementID;
	$("#ABR-item-"+x+"-"+y).html("");
	$("#ABR-amount-"+x+"-"+y).html("");
	var addTotal = calculateTotal();
    financingCalculator();
}
function addItemCustom (groupID, elementID, name, amount) {
	var x=(groupID>9)?groupID:"0"+groupID; var y=(elementID>9)?elementID:"0"+elementID;
	$("#ABR-item-"+x+"-"+y).html(name);
	$("#ABR-amount-"+x+"-"+y).html(amount);
	var addTotal = calculateTotal();
    financingCalculator();
}
function removeItemName (elementName) {
	$("#"+elementName).html("");
	$("#"+elementName).html("");
	var addTotal = calculateTotal();
    financingCalculator();
}
function setElementValue (groupID, elementID, text) {
	var x=(groupID>9)?groupID:"0"+groupID;
  	var y=(elementID>9)?elementID:"0"+elementID;
	$("#ABR-ID-"+x+"-"+y).val(text);
}
function setLabelValue (groupID, elementID, text) {
	var x=(groupID>9)?groupID:"0"+groupID;
  	var y=(elementID>9)?elementID:"0"+elementID;
	$("#ABR-ID-"+x+"-"+y+"-label").html(text);
}
function addValue (groupID, elementStart, elementEnd, text) {
	var x=(groupID>9)?groupID:"0"+groupID;
	for (var j=elementStart; j<=elementEnd; j++) {
		var y=(j>9)?j:"0"+j;
		$("#ABR-ID-"+x+"-"+y).val(text);
	}
}
function appendValue (groupID, elementStart, elementEnd, text) {
	var x=(groupID>9)?groupID:"0"+groupID;
	for (var j=elementStart; j<=elementEnd; j++) {
		var y=(j>9)?j:"0"+j;
		$("#ABR-ID-"+x+"-"+y).val($("#ABR-ID-"+x+"-"+y).val()+text);
	}
}
function addLabelValue (groupID, elementStart, elementEnd, item, amount) {
	var x=(groupID>9)?groupID:"0"+groupID;
	for (var j=elementStart; j<=elementEnd; j++) {
		var y=(j>9)?j:"0"+j;
		$("#ABR-ID-"+x+"-"+y).val(item+" "+$("#ABR-ID-"+x+"-"+y+"-label").text()+" "+amount);
	}
}
function isChecked(groupID, elementID) {
	return document.getElementById(elements[groupID][elementID]).checked;
}
function isGroupChecked(groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {if (isChecked(groupID, i)) {return true;}}
	return false;
}
function isRangeChecked(groupID, elementID, elementStart, elementEnd) {
	for (var j=elementStart; j<=elementEnd; j++) {
		if ((elementID == j) && isChecked(groupID, elementID)) {return true;}
	}
	return false;
}
function isVisible (elementName) {
	if (document.getElementById(elementName).style.display != "none") {return true;}
	else {return false;}
}
function checkElement (groupID, elementID) {
	if (isLive && !beginProcess) {beginProcess = true; ga('send', 'event', 'Amish Barn Raiser Guide', 'Begin');}	//	Google Analytics event: first element selected
	enableElement(groupID, elementID);
	document.getElementById(elements[groupID][elementID]).checked = true;
	addItem(groupID, elementID);
}
function checkGroup (groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {checkElement(groupID, i);}
}
function unCheckElement (groupID, elementID) {
	document.getElementById(elements[groupID][elementID]).checked = false;
	removeItem(groupID, elementID);
}
function unCheckGroup (groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {unCheckElement(groupID, i);}
}
function isEnabled (groupID, elementID) {
	if (!document.getElementById(elements[groupID][elementID]).disabled) {return true;}
	else {return false;}
}
function enableElement (groupID, elementID) {
	document.getElementById(elements[groupID][elementID]).disabled = false;
	var elementExists = !!document.getElementById(elements[groupID][elementID]+"-color");
	if (elementExists) {$(document.getElementById(elements[groupID][elementID]+"-color")).removeClass("ABR-disabled").addClass("ABR-enabled");}
	$(document.getElementById(elements[groupID][elementID]+"-label")).removeClass("ABR-disabled").addClass("ABR-enabled");
}
function disableElement (groupID, elementID) {
	unCheckElement (groupID, elementID);
	document.getElementById(elements[groupID][elementID]).disabled = true;
	var elementExists = !!document.getElementById(elements[groupID][elementID]+"-color");
	if (elementExists) {$(document.getElementById(elements[groupID][elementID]+"-color")).removeClass("ABR-enabled").addClass("ABR-disabled");}
	$(document.getElementById(elements[groupID][elementID]+"-label")).removeClass("ABR-enabled").addClass("ABR-disabled");
}
function enableGroup (groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {enableElement(groupID, i);}
}
function disableGroup (groupID, elementStart, elementEnd) {
	for (var i=elementStart; i<=elementEnd; i++) {disableElement(groupID, i);}
}
function showElement (groupID, elementID) {
	enableElement(groupID, elementID);
	document.getElementById(elements[groupID][elementID]+"-container").style.display = "block";
}
function showElementName (elementName) {
	document.getElementById(elementName).style.display = "block";
}
function hideDiv (ID) {
  	var res = ID.split(",");
  	for (var i = 0; i < res.length; i++) {
        document.getElementById(res[i]).style.display = "none";
    }
	
}
function showDiv (ID) {
  	var res = ID.split(",");
  	for (var i = 0; i < res.length; i++) {
        document.getElementById(res[i]).style.display = "block";
    }
}
function hideElement (groupID, elementID) {
	disableElement(groupID, elementID);
	document.getElementById(elements[groupID][elementID]+"-container").style.display = "none";
}
function hideElementName (elementName) {
	document.getElementById(elementName).style.display = "none";
}
function radioGroupA (groupID, elementID, elementStart, elementEnd) {
	if ((elementID >= elementStart) && (elementID <= elementEnd)) {
		for (var i=elementStart; i<=elementEnd; i++) {
			if (i!=elementID) {unCheckElement(groupID, i);}
			else {checkElement(groupID, i);}
		}
	}
}
function radioGroupB (groupID, elementID, elementStart, elementEnd) {
	if ((elementID >= elementStart) && (elementID <= elementEnd)) {
		for (var i=elementStart; i<=elementEnd; i++) {
			if (i!=elementID) {unCheckElement(groupID, i);}
		}
	}
}

/*** ELEMENT FUNCTIONS: DO NOT MODIFY ***/



/*** CREATE DIALOG: DO NOT MODIFY ***/
function createDialog(alert, type, ifYes, ifNo) {
	if (type == "confirm") {
		vex.dialog.confirm({
			message: alert,
			buttons: [$.extend({}, vex.dialog.buttons.YES, {text:"Yes"}), $.extend({}, vex.dialog.buttons.NO, {text:"No"})],
			callback: function(value) {if (value) {ifYes();} else {ifNo();}}
		});
	}
	if (type == "alert") {
		vex.dialog.alert({
			message: alert,
			callback: function(value) {if (value) {ifYes();}}
		});
	}
}
/*** CREATE DIALOG: DO NOT MODIFY ***/



/*** INPUT CHANGE: DO NOT MODIFY ***/
$(".ABR-color, .ABR-label, .ABR-click").bind("click", function(e) {
	var groupID = parseInt($(this).attr("id").substring(7,9));
	var elementID = parseInt($(this).attr("id").substring(10,12));
	if (isEnabled(groupID, elementID)) {checkElement(groupID, elementID);}
	decisionTree(groupID, elementID);
	if (isChecked(groupID,elementID)) {addItem(groupID, elementID);}
	else {removeItem(groupID, elementID);}
});
$("input").bind("click", function(e) {
	if (($(this).attr("id") != "FNAME") && ($(this).attr("id") != "LNAME") && ($(this).attr("id") != "PHONE") && ($(this).attr("id") != "EMAIL") && ($(this).attr("id") != "SUBMITBUTTON")) {		//	Don’t trigger for MailChimp input fields
		var groupID = parseInt($(this).attr("id").substring(7,9));
		var elementID = parseInt($(this).attr("id").substring(10,12));
		decisionTree(groupID, elementID);
		if (isChecked(groupID,elementID)) {addItem(groupID, elementID);}
		else {removeItem(groupID, elementID);}
	}
});
$("#MailChimpForm").submit(function() {
	checkFields();
	initMailChimp();																	//	Fill out MailChimp input fields before submitting form
	if (completeProcess) {
      	
		return true;
	}
	else {return false;}																//	Return false to cancel form action
});
/*** INPUT CHANGE: DO NOT MODIFY ***/

if(isLive) {ga('send', 'event', 'Amish Barn Raiser Guide', 'Page loaded');}				//	Google Analytics event: page loaded, but process not necessarily begun.
});																						//	$(document).ready(function() {}); closing bracket